import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/getMostrarSeleccionInformePersonalizadoCliente`, method: 'POST', body: list, token: token})
}